import { Component, EventEmitter, Input, OnInit, Output, inject, DestroyRef } from '@angular/core';
import { SolutionVersionsInfo } from 'src/app/models/service/solution-versions-info';
import { Solution } from 'src/app/models/service/solution';
import { ChangeTaskService } from 'src/app/services/api/change-task.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ChangeState } from 'src/app/models/service/change-state';
import { SolutionVersion } from 'src/app/models/service/solution-version';
import { combineLatest } from 'rxjs';
import { ChangeTask } from 'src/app/models/service/change-task';
import { translate } from '@jsverse/transloco';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ContactUsDialogComponent } from 'src/app/layout/toolbar/contact-us-dialog/contact-us-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DeferUpdateDialogComponent } from './defer-update-dialog/defer-update-dialog.component';
import { finalize } from 'rxjs/operators';
import { Blueprint } from 'src/app/models/blueprints/blueprint';

const MAX_DEFFERALS = 2;

@Component({
    selector: 'app-auto-update-info',
    templateUrl: './auto-update-info.component.html',
    styleUrls: ['./auto-update-info.component.scss'],
    standalone: false
})
export class AutoUpdateInfoComponent implements OnInit {

  @Input() service: Solution;
  @Input() blueprint: Blueprint;
  @Output() changeTaskChange = new EventEmitter<ChangeTask>();
private destroyRef = inject(DestroyRef);
  _serviceVersionsInfo: SolutionVersionsInfo;
  @Input() set serviceVersionsInfo(solutionVersionsInfo) {
    const shouldLoadData = this._serviceVersionsInfo != null;
    this._serviceVersionsInfo = solutionVersionsInfo;
    if (shouldLoadData) {
      this.loadData();
    }
  };

  get serviceVersionsInfo(): SolutionVersionsInfo {
    return this._serviceVersionsInfo;
  }

  activeServiceVersion: SolutionVersion;
  // Remaining deferrals cound i.e. MAX_DEFFERALS - deferrals cound
  deferralCount: number;
  defferLabel: string;
  changeTask: ChangeTask;
  ChangeState = ChangeState;
  isUpdateAvailable: boolean;
  dataLoading: boolean;
  updateVersionChangeTask: any;

  constructor(private sidenavService: SidenavService, private changeTaskService: ChangeTaskService, private matDialog: MatDialog) {
  }

  ngOnInit(): void {
    this.loadData();
  }

  openContactUsForm(): void {
    this.sidenavService.openInRightSidenav(ContactUsDialogComponent);
  }

  openDeferUpdateDialog(): void {
    this.matDialog.open(DeferUpdateDialogComponent, {
      data: {
        deferralCount: this.deferralCount,
        changeTaskId: this.changeTask.id,
      },
      autoFocus: false
    })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(deferred => {
          if (deferred) {
            this.loadData();
          }
        });
  }

  private resolveData(changeTask: ChangeTask, deferrals: any): void {
    if (!changeTask) {
      return;
    }

    if (ChangeState.PENDING_APPLICATION === changeTask.changeState) {
      this.deferralCount = MAX_DEFFERALS - parseInt(deferrals[changeTask.blueprintId], 10);
      this.defferLabel = this.resolveDeferralLabel();
    }

    this.isUpdateAvailable = ChangeState.PENDING_APPLICATION === changeTask.changeState || ChangeState.APPLYING === changeTask.changeState;
  }

  private resolveDeferralLabel(): string {
    if (this.deferralCount > 1) {
      return translate('AUTO_UPDATE.CAN_BE_SKIPPED_TIMES', {deferralCount: this.deferralCount});
    }
    if (this.deferralCount === 1) {
      return translate('AUTO_UPDATE.CAN_BE_SKIPPED_ONCE');
    }
    return translate('AUTO_UPDATE.CANT_BE_SKIPPED');
  }

  private loadData(): void {
    if (this.serviceVersionsInfo.updateVersion) {
      this.dataLoading = true;
      combineLatest([
        this.changeTaskService.getChangeTasks({solutionVersionId: this.serviceVersionsInfo.updateVersion.id,
          blueprintId: this.blueprint.id}),
        this.changeTaskService.getDeferrals()
      ])
        .pipe(
          finalize(() => this.dataLoading = false),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe(([changeTasks, deferrals]) => {
          if(changeTasks?.length) {
            this.updateVersionChangeTask = changeTasks[0];
            this.changeTaskChange.emit(this.updateVersionChangeTask);
            if (this.updateVersionChangeTask?.changeState !== ChangeState.REJECTED || !this.serviceVersionsInfo?.comingSoonVersion) {
              this.changeTask = this.updateVersionChangeTask;
              this.resolveData(this.changeTask, deferrals);
              this.activeServiceVersion = this.serviceVersionsInfo.updateVersion;
            } else {
              this.activeServiceVersion = this.serviceVersionsInfo?.comingSoonVersion;
            }
          }
        });
    } else {
      this.activeServiceVersion = this.serviceVersionsInfo?.comingSoonVersion;
    }
  }
}
